import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AuthProvider } from './AuthContext';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider, CssBaseline, createTheme } from '@mui/material';
import { LoadingProvider } from "./context/LoadingContext";

const theme = createTheme({
  direction: 'rtl',
  palette: {
    primary: { main: "#2d2e77", contrastText: "#fff" },
    secondary: { main: "#ff6175" },
    error: { main: "#ae3034", contrastText: "#fff" },
    warning: { main: "#ffb958", contrastText: "#fff" },
    success: { main: "#31c388", contrastText: "#fff" },
    info: { main: '#2781d5', contrastText: "#fff" },
  },
  components: {
    MuiChip: {
      styleOverrides: {
        root: {
          margin: '1px',
          '& .MuiChip-label.MuiChip-labelMedium': {
            padding: '0 10px', // تغییر padding برای size small
            fontSize: '0.75rem', // تغییر اندازه فونت
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        tag: {
          margin: '2px',
          height: '25px',
          root: {
            '& .MuiChip-label.MuiChip-labelMedium': {
              padding: '2px 10px', // تغییر padding برای size small
              fontSize: '0.75rem', // تغییر اندازه فونت
            },
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        sizeSmall: {
          padding: "2px 10px",
        },
      },
    },
  },
  typography: {
    fontFamily: 'IRANSans, Arial, sans-serif',
    allVariants: {
      textAlign: 'right', // Ensure all Typography elements are aligned right
    },

  },
});
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <Router>
      <AuthProvider>
        <LoadingProvider>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <App />
          </ThemeProvider>
        </LoadingProvider>
      </AuthProvider>
    </Router>
  </React.StrictMode>
);